module.exports = __webpack_public_path__ + "static/media/money.cb847068.svg";